import { Iteration } from 'schemas/Iteration.schema';
import { hasRoutingPlanErrors } from 'utils/iterationUtils';
import { CampaignConfig } from 'schemas/CampaignConfig.schema.ts';

// eslint-disable-next-line import/prefer-default-export
export function useCampaignStatus(campaign: CampaignConfig) {
  const hasIterationErrors = (iteration: Iteration): boolean => {
    if (
      !iteration.Type
            || !iteration.IterationCohorts?.length
            || !iteration.DefaultCommsRouting?.length
            || hasRoutingPlanErrors(iteration)
    ) {
      return true;
    }

    return false;
  };

  const hasErrors = (): boolean => {
    const iterations = campaign.CampaignConfig?.Iterations || [];
    return iterations.some((iteration: Iteration) => hasIterationErrors(iteration));
  };

  const iterationsWithErrors = (): Iteration[] => {
    const iterations = campaign.CampaignConfig?.Iterations || [];
    return iterations.filter((iteration: Iteration) => hasIterationErrors(iteration));
  };

  return {
    hasErrors, hasIterationErrors, iterationsWithErrors, hasRoutingPlanErrors,
  };
}
